var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('b-card',[_c('remnant-past-apply',{ref:"remnantPastApply",attrs:{"email":_vm.$store.state.EMAIL}})],1),_c('b-card',[_c('remnant-past-review',{ref:"remnantPastReview",attrs:{"email":_vm.$store.state.EMAIL,"no-review":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }